const wishlistCelebrations = new WeakMap();

const celebrateWishlistSave = (button) => {
  wishlistCelebrations.get(button)?.();
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (button.classList.contains('sm-card-save')) {
    const icon = button.querySelector('.sm-save-heart');
    icon?.animate([{transform:'scale(.88)'},{transform:'scale(1)'}],{duration:180,easing:'ease-out'});
    return;
  }
  const children = [...button.children];
  const opacity = children.map((child) => child.style.opacity);
  const position = button.style.position;
  if (getComputedStyle(button).position === 'static') button.style.position = 'relative';
  const burst = document.createElement('span');
  burst.className = 'bb-wishlist-heart-burst';
  burst.setAttribute('aria-hidden', 'true');
  burst.style.cssText = 'position:absolute;inset:0;display:grid;place-items:center;pointer-events:none;color:inherit;';
  burst.innerHTML = '<svg width="40" height="40" viewBox="0 0 48 48" fill="none" style="overflow:visible"><circle data-heart-ring cx="24" cy="24" r="13" stroke="currentColor" stroke-width="1.3" opacity="0"/><g data-heart-rays stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0"><path d="M24 3v4M24 41v4M3 24h4M41 24h4M9 9l3 3M36 36l3 3M9 39l3-3M36 12l3-3"/></g><path data-heart-shape fill="currentColor" d="M24 35s-12-7.6-12-15a6.7 6.7 0 0 1 12-4 6.7 6.7 0 0 1 12 4c0 7.4-12 15-12 15Z"/></svg>';
  children.forEach((child) => { child.style.opacity = '0'; });
  button.append(burst);
  const animations = [];
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const heart = burst.querySelector('[data-heart-shape]');
    const ring = burst.querySelector('[data-heart-ring]');
    const rays = burst.querySelector('[data-heart-rays]');
    [heart, ring, rays].forEach((part) => { part.style.transformOrigin = '24px 24px'; });
    animations.push(heart.animate([
      {opacity: 0, transform: 'scale(.55)'},
      {opacity: 1, transform: 'scale(1)', offset: .265},
      {opacity: 1, transform: 'scale(1)', offset: .65},
      {opacity: 1, transform: 'scale(1.2)', offset: .78},
      {opacity: 1, transform: 'scale(1)'},
    ], {duration: 1000, easing: 'ease-out', fill: 'both'}));
    animations.push(ring.animate([
      {opacity: .65, transform: 'scale(.65)'},
      {opacity: 0, transform: 'scale(1.45)'},
    ], {duration: 320, delay: 665, easing: 'ease-out', fill: 'forwards'}));
    animations.push(rays.animate([
      {opacity: 0, transform: 'scale(.7)'},
      {opacity: 1, transform: 'scale(.9)', offset: .25},
      {opacity: 0, transform: 'scale(1.2)'},
    ], {duration: 320, delay: 665, easing: 'ease-out', fill: 'forwards'}));
  }
  const timer = setTimeout(() => cleanup(), 1800);
  const cleanup = () => {
    clearTimeout(timer);
    animations.forEach((animation) => animation.cancel());
    burst.remove();
    children.forEach((child, index) => { child.style.opacity = opacity[index]; });
    button.style.position = position;
    wishlistCelebrations.delete(button);
  };
  wishlistCelebrations.set(button, cleanup);
};

const updateButton = (button, saved) => {
  button.setAttribute('aria-pressed', String(saved));
  const label = button.querySelector('[data-bb-wishlist-label]');
  if (label) label.textContent = saved ? 'SAVED TO WISHLIST' : 'SAVE TO WISHLIST';
  const icon = button.querySelector('[aria-hidden="true"]');
  if (icon && icon.tagName.toLowerCase() !== 'svg') icon.textContent = saved ? '♥' : '♡';
};

let wishlistLoad;
const loadWishlist = async (button) => {
  wishlistLoad ||= fetch(button.dataset.endpoint, {credentials: 'same-origin', headers: {Accept: 'application/json'}}).then(async response => response.ok ? response.json() : {items:[]});
  const payload = await wishlistLoad;
  updateButton(button, (payload.items || []).some((item) => item.productGid === button.dataset.productGid));
};

const toggleWishlist = async (button) => {
  if (button.disabled) return;
  wishlistCelebrations.get(button)?.();
  if (button.dataset.customerAuthenticated !== 'true') {
    try {
      const saved = window.SMSavedPieces.toggle(button);
      if (saved) celebrateWishlistSave(button);
    } catch (error) { window.SMSavedPieces?.announce(error.message); }
    return;
  }
  wishlistCelebrations.get(button)?.();
  button.disabled = true;
  const wasSaved = button.getAttribute('aria-pressed') === 'true';
  try {
    const response = await fetch(button.dataset.endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({
        action: wasSaved ? 'remove' : 'save',
        productGid: button.dataset.productGid,
        variantGid: button.closest('form')?.querySelector('input[name="id"]')?.value ? 'gid://shopify/ProductVariant/' + button.closest('form').querySelector('input[name="id"]').value : button.dataset.variantGid || null,
      }),
    });
    if (response.status === 401) {
      window.location.assign(button.dataset.loginUrl || '/account/login');
      return;
    }
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.message || 'Wishlist update failed.');
    document.querySelectorAll('[data-bb-membership-wishlist]').forEach(other => { if (other.dataset.productGid === button.dataset.productGid) updateButton(other, !wasSaved); });
    if (!wasSaved) celebrateWishlistSave(button);
  } catch (error) {
    const label = button.querySelector('[data-bb-wishlist-label]');
    if (label) label.textContent = (error.message || 'TRY AGAIN').replace('Blueprint wishlist', 'wishlist');
  } finally {
    button.disabled = false;
  }
};

const initializeWishlist = (root = document) => {
  root.querySelectorAll('[data-bb-membership-wishlist]').forEach((button) => {
    if (button.dataset.bbWishlistReady === 'true') return;
    button.dataset.bbWishlistReady = 'true';
    // A delegated listener also handles collection cards replaced by filters.
    if (button.dataset.customerAuthenticated === 'true') loadWishlist(button).catch(() => {});
  });
};

document.addEventListener('DOMContentLoaded', () => initializeWishlist());
document.addEventListener('shopify:section:load', (event) => initializeWishlist(event.target));

document.addEventListener('click', event => {
  const button = event.target.closest('[data-bb-membership-wishlist]');
  if (button) toggleWishlist(button);
});
